// ======================================================================
// File Name       : ContentDistributionUsageDetail
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import PropTypes from 'prop-types';
import { Form, Table, Button, FormControl, Col, InputGroup } from 'react-bootstrap';
import moment from 'moment';
import Datetime from 'react-datetime';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import CourseTreeContainer from '../course/CourseTreeContainer';
import { MIN_DATE, MAX_DATE, MIN_MAX_DATE_TXT } from '../../utils/index';
import ModalConductor from '../../components/modal/ModalConductor';
import ContentDistributionUsageSearch from '../../components/contentDistribution/ContentDistributionUsageSearch';
import ContentDistributionUsageList from '../../components/contentDistribution/ContentDistributionUsageList';
import ContentDistributionUsageInfo from '../../components/contentDistribution/ContentDistributionUsageInfo';
import CourseDistributionUsageList from '../../components/contentDistribution/CourseDistributionUsageList';
import DialogConfirm from '../../components/DialogConfirm';
import * as MessageTemplate from '../../constants/MessageTemplate';
import PaginationCustom from '../../components/Pagination';
import { CONTENT_DISTRIBUTION, CONTENT_DISTRIBUTION_LIST } from '../../constants/PathConstants';
import {
  distributionServiceSearch,
  contentDistributionUsageDetail,
  courseDistributionUsageDetail,
} from '../../actions/ContentDistributionAction';
import { RETURN_MAX_NUM, DEFAULT_DATE_FORMAT_SERVER } from '../../constants/index';
import { COURSE, CONTENT } from '../../constants/ContentDistributionConstant';
import Header from '../../components/Header';
import CustomButton from '../../components/button/CustomButton';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';

const propTypes = {
  dispatch: PropTypes.func.isRequired,

};
class ContentDistributionUsageDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filterData: {
        name: '',
        publicStatus: '',
        contentType: '',
        acquisitionStartDate: moment().add(-7, 'days'),
        acquisitionEndDate: moment().add(-1, 'days'),
      },
      contentDistributionSearchUsage: {
        serviceName: '',
        companyName: '',
        distributionType: '',
      },
      distributionUsedContentSortType: '',
      distributionUsedCourseSortType: '',
      ascendingDescendingSort: 0,
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
      showDialog: false,
      contentDistributionUsage: null,
      courseDistributionUsage: null,
      contentDistributionSearchInfo: {
        distributionType: COURSE,
      },
    };
    this.resetPage = true;
    this.onSearchData = this.onSearchData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.onDeleteAuthorityCancel = this.onDeleteAuthorityCancel.bind(this);
    this.onDeleteAuthorityOk = this.onDeleteAuthorityOk.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.getContentDistributionUsage = this.getContentDistributionUsage.bind(this);
    this.openDeleteConfirmDialog = this.openDeleteConfirmDialog.bind(
      this,
      MessageTemplate.BULK_EXPORT,
      null,
    );
    this.validation = this.validation.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    const { match } = this.props;
    if (match) {
      this.onSearchData();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { contentDistribution } = nextProps;
    const { contentDistributionUsage, courseDistributionUsage } = contentDistribution;
    this.setState({
      contentDistributionUsage,
      courseDistributionUsage,
    });
  }

  /**
   * handle change for user input
   * @param {*} event
   */
  handleChange(event) {
    const { name, value } = event.target;
    const contentDistributionSearchInfo = {
      ...this.state.contentDistributionSearchInfo,
      ...{ [name]: value },
    };
    this.setState({ contentDistributionSearchInfo }, () => {
      this.onSearchData();
    });
  }

  handleInputChange(name, value) {
    const filterData = { ...this.state.filterData, ...{ [name]: value } };
    this.setState({
      filterData,
    });
  }
  /**
   * handle sorting data
   * @param {*} row
   */
  handleSortState(row) {
    const { contentDistributionSearchInfo } = this.state;
    const { distributionType } = contentDistributionSearchInfo;
    if (!this.validation()) {
      return;
    }
    this.setState(
      {
        distributionUsedContentSortType: row.sortBy,
        ascendingDescendingSort: row.sortState,
        distributionUsedCourseSortType: row.sortBy,
      },
      () => {
        if (parseInt(distributionType, 10) === COURSE) {
          this.getContentDistributionUsage(true, 0, true);
        } else {
          this.getContentDistributionUsage(true, 0, false);
        }
      },
    );
  }
  /**
   * Pagination
   * @param {*} page
   */
  getStartEndData(startPosition) {
    const { contentDistributionSearchInfo } = this.state;
    const { distributionType } = contentDistributionSearchInfo;
    if (!this.validation()) {
      return;
    }
    this.setState(
      {
        startPosition,
      },
      () => {
        if (parseInt(distributionType, 10) === COURSE) {
          this.getContentDistributionUsage(true, 0, true);
        } else {
          this.getContentDistributionUsage(true, 0, false);
        }
      },
    );
  }
  /**
   * Get content distribution list when click button search
   */
  onSearchData() {
    const { contentDistributionSearchInfo } = this.state;
    const { distributionType } = contentDistributionSearchInfo;
    if (!this.validation()) {
      return;
    }
    this.setState({
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
      distributionUsedContentSortType: null,
      distributionUsedCourseSortType: null,
      ascendingDescendingSort: null,
    }, () => {
      if (parseInt(distributionType, 10) === COURSE) {
        this.getContentDistributionUsage(true, 0, true);
      } else {
        this.getContentDistributionUsage(true, 0, false);
      }
    });
  }
  /**
   * Get content distribution list
   *
   */
  getContentDistributionUsage(resetPage, selectTargetData, isCourseDistribution) {
    if (!this.validation()) {
      return;
    }
    const auth = this.props.auth;
    const type = this.state.contentDistributionSearchUsage.distributionType;
    this.resetPage = resetPage;
    const param = {
      authCd: auth.authCd,
      selectTargetData,
      distributionServiceCd: this.props.match.params.id,
      ascendingDescendingSort: this.state.ascendingDescendingSort,
      startPosition: this.state.startPosition,
      returnMaxNum: this.state.returnMaxNum,
    };
    if (parseInt(this.state.contentDistributionSearchInfo.distributionType, 10) === COURSE) {
      param.distributionUsedCourseSortType = this.state.distributionUsedCourseSortType;
    } else {
      param.distributionUsedContentSortType = this.state.distributionUsedContentSortType;
    }
    if (this.state.filterData.acquisitionStartDate) {
      param.acquisitionStartDate = moment(this.state.filterData.acquisitionStartDate).startOf('day').format(
        DEFAULT_DATE_FORMAT_SERVER,
      );
    }
    if (this.state.filterData.acquisitionEndDate) {
      param.acquisitionEndDate = this.state.filterData.acquisitionEndDate && this.state.filterData.acquisitionEndDate !== '' ? moment(this.state.filterData.acquisitionEndDate).endOf('day').format(
        DEFAULT_DATE_FORMAT_SERVER,
      ) : '';
    }
    if (isCourseDistribution) {
      this.props.dispatch(courseDistributionUsageDetail(param));
    } else {
      this.props.dispatch(contentDistributionUsageDetail(param));
    }
  }
  /**
   * Show delete authority confirm dialog
   * @param {*} mdContent
   * @param {*} mdSize
   */
  openDeleteConfirmDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showDialog: true });
  }
  /**
   * Event button cancel of delete confirm dialog clicked
   */
  onDeleteAuthorityCancel() {
    this.setState({ showDialog: false });
  }
  /**
   * Event button ok of delete confirm dialog clicked
   */
  onDeleteAuthorityOk() {
    const { contentDistributionSearchInfo } = this.state;
    const { distributionType } = contentDistributionSearchInfo;
    if (parseInt(distributionType, 10) === COURSE) {
      this.getContentDistributionUsage(true, 1, true);
    } else {
      this.getContentDistributionUsage(true, 1, false);
    }
    this.setState({ showDialog: false });
  }

  validation() {
    return Object.keys(this.refsToValidate).every(
      ref => this.refsToValidate[ref].validation && this.refsToValidate[ref].validation(),
    );
  }

  render() {
    this.refsToValidate = [];
    const { filterData, modaleData, contentDistributionSearchInfo } = this.state;
    const to = `${CONTENT_DISTRIBUTION_LIST}`;
    let distributionType = COURSE;
    let distributionServiceName = '';
    if (contentDistributionSearchInfo && contentDistributionSearchInfo.distributionType) {
      distributionType = parseInt(contentDistributionSearchInfo.distributionType, 10);
    }
    let distributionUsage = this.state.courseDistributionUsage;
    if (parseInt(contentDistributionSearchInfo.distributionType, 10) === CONTENT) {
      distributionUsage = this.state.contentDistributionUsage;
    }
    let recordNum = 0;
    if (this.state.contentDistributionUsage && distributionType === CONTENT) {
      recordNum = this.state.contentDistributionUsage.recordNum;
      distributionServiceName = this.state.contentDistributionUsage.distributionServiceName;
    } else if (this.state.courseDistributionUsage && distributionType === COURSE) {
      recordNum = this.state.courseDistributionUsage.recordNum;
      distributionServiceName = this.state.courseDistributionUsage.distributionServiceName;
    }
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.CONTENT_DISTRIBUTION_LIST}
          text="コンテンツ配布管理に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="配布先サービスの利用状況詳細" />
        <Col sm={12}>
          <Form className='form-horizontal'>
            <Form.Group>
              <Col sm={3} className="margin-top-10 margin-bottom-10 float-start">
                配布先サービス名
              </Col>
              <Col sm={9} className="margin-top-10 float-end">
                {distributionServiceName}
              </Col>
            </Form.Group>
            <br />
            <ContentDistributionUsageSearch
              {...filterData}
              onInputChange={this.handleInputChange}
              onSearchBtnClick={this.onSearchData}
              ref={(ref) => {
                if (ref) {
                  this.refsToValidate.push(ref);
                }
              }}
            />
            <Form.Group>
              <ContentDistributionUsageInfo
                distributionUsage={distributionUsage}
                handleSortState={this.handleSortState}
                handleChange={this.handleChange}
                distributionType={distributionType}
              />
            </Form.Group>
            <Form.Group>
              <Col sm={12}>
                <Col sm={6} className="margin-top-35 padding-left-clear">
                  {distributionType && distributionType === CONTENT ? '配布コンテンツ利用状況一覧' : '配布コース利用状況一覧'}
                </Col>
              </Col>
            </Form.Group>
            <Form.Group>
              <Col sm={12} className="margin-top-10 margin-bottom-10 padding-left-right-clear">
                ※ユーザーが実施していないコンテンツはリストに表示されません
              </Col>
            </Form.Group>
            <Form.Group>
              {distributionType === COURSE
                ?
                <CourseDistributionUsageList
                  courseDistributionUsage={this.state.courseDistributionUsage}
                  handleSortState={this.handleSortState}
                  dataSort={this.state}
                />
                :
                <ContentDistributionUsageList
                  contentDistributionUsage={this.state.contentDistributionUsage}
                  handleSortState={this.handleSortState}
                  dataSort={this.state}
                />
              }

            </Form.Group>
            <Form.Group>
              <Col sm={12}>
                <Col sm={6} className="margin-top-20 float-start">
                  {/* <LinkContainer to={to}>
                    <Button bsStyle="primary" className="btn-96">
                      戻る
                    </Button>
                  </LinkContainer> */}
                </Col>
                <Col sm={6} className="margin-top-20 float-end">
                  {/* <Button
                  className="btn-96 btn btn-primary float-end"
                  onClick={this.openDeleteConfirmDialog}
                >
                  export
                </Button> */}
                  <CustomButton
                    btnStyle="btn btn-export-csv float-end"
                    handleClick={this.openDeleteConfirmDialog}
                    text="一括出力"
                    iconClass="bi bi-download"
                  />
                </Col>
              </Col>
              <DialogConfirm
                showModal={this.state.showDialog}
                onCancel={this.onDeleteAuthorityCancel}
                mdSize={this.mdSize}
                content={this.content}
                onOK={this.onDeleteAuthorityOk}
              />
            </Form.Group>
            <Form.Group>
              <Col sm={12} className="d-flex justify-content-center">
                <PaginationCustom
                  className="text-center"
                  recordNum={recordNum}
                  handlePageSelect={this.getStartEndData}
                  startPosition={this.state.startPosition}
                />
              </Col>
            </Form.Group>
          </Form>
        </Col>
      </div>
    );
  }
}

// ContentDistributionUsageDetail.propTypes = propTypes;
const mapStateToProps = (state, ownProps) => ({
  ...{
    contentDistribution: state.contentDistribution,
    auth: state.authed.authedUser,
  },
});
export default connect(mapStateToProps)(ContentDistributionUsageDetail);
